import BaseModel from './BaseModel';
import Classroom from './Classroom';
import i18n from '../locales/i18n';

/** Class representing a group. */
class Group extends BaseModel {
    constructor(properties) {
        super(properties);

        if ('classrooms' in this)
            this.classrooms = this.classrooms.map(c => new Classroom(c));
    }


    getAgesText() {
        return [
            this.min_age,
            i18n.t('common.age_years'),
            '-',
            this.max_age,
            i18n.t('common.age_years')
        ].join(' ');
    }
}

export default Group;
